/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["span[_ngcontent-%COMP%]{color:#444}span.ap-points[_ngcontent-%COMP%]{font-size:1rem;font-weight:800;padding-bottom:1px}span.ap-label[_ngcontent-%COMP%], span.ap-points[_ngcontent-%COMP%]{font-family:Inter,Arial,Helvetica,sans-serif}span.ap-label[_ngcontent-%COMP%]{font-size:.75rem;font-weight:900;padding:0 .2rem;border:1px solid #444}"];
export { styles as styles };
//# sourceMappingURL=gamification-activity-points.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/gamification-activity-points/gamification-activity-points.component.scss.shim.ngstyle.js
// module id = 1406
// module chunks = 26 27 28